import {createSelector} from 'reselect'

export const getTextSearchMessage = createSelector(
  state => state && state.vehicleParts && state.vehicleParts.list && state.vehicleParts.list.textSearchMessage,
  textSearchMessage => textSearchMessage
)
